import { n_book_lessons, n_tutor } from '../i18n/strings/auto/wording'
import useTranslation from '../i18n/useTranslation'

const useFilterItems = () => {
  const { t } = useTranslation()
  const strengthsItems = [
    {
      text: t(n_tutor.str.option_1),
      alt: 'beginner',
      value: 1,
    },
    {
      text: t(n_tutor.str.option_2),
      alt: 'speaking',
      value: 2,
    },
    {
      text: t(n_tutor.str.option_3),
      alt: 'academic_interview',
      value: 5,
    },
    {
      text: t(n_tutor.str.option_4),
      alt: 'job_interview',
      value: 4,
    },
    {
      text: t(n_tutor.str.option_5),
      alt: 'business',
      value: 3,
    },
    {
      text: t(n_tutor.str.option_6),
      alt: 'testprep',
      value: 6,
    },
    { text: t(n_tutor.str.option_7), alt: 'writing', value: 7 },
  ]

  const fieldOfStudiesItems = [
    {
      text: t(n_tutor.dep.option_1),
      alt: 'social_sciences',
      value: 1,
    },
    {
      text: t(n_tutor.dep.option_2),
      alt: 'liberal_arts',
      value: 2,
    },
    {
      text: t(n_tutor.dep.option_6),
      alt: 'business_economics',
      value: 3,
    },
    {
      text: t(n_tutor.dep.option_4),
      alt: 'natural_sciences',
      value: 4,
    },
    { text: t(n_tutor.dep.option_3), alt: 'engineering', value: 5 },
    { text: t(n_tutor.dep.option_7), alt: 'medical_sciences', value: 6 },
    { text: t(n_tutor.dep.option_8), alt: 'law', value: 7 },
    { text: t(n_tutor.dep.option_5), alt: 'fine_arts_athletics', value: 8 },
  ]

  const experienceItems = [
    {
      value: 1,
      text: t(n_tutor.exp.option_1),
      alt: 'work_experience',
    },
    {
      value: 2,
      text: t(n_tutor.exp.option_2),
      alt: 'graduate_school',
    },
  ]

  const accentItems = [
    { text: t(n_book_lessons.filter.accent_usa), alt: 'american', value: 0 },
    { text: t(n_book_lessons.filter.accent_british), alt: 'british', value: 2 },
  ]

  const genderItems = [
    { text: t(n_book_lessons.filter.gender_male), alt: 'male', value: 1 },
    { text: t(n_book_lessons.filter.gender_female), alt: 'female', value: 0 },
  ]

  return {
    strengthsItems,
    fieldOfStudiesItems,
    experienceItems,
    accentItems,
    genderItems,
  }
}

export default useFilterItems
